// Heroku 配置-------------------------------------------------
// 后端服务器地址
export const apiURL = "https://ghdocs-backend.rhino3d.com";
export const appPath = "/docs/";
export const isDevelopEnv = false;
// 编译配置结束----------------------------------------------

// // 编译配置-------------------------------------------------
// // 后端服务器地址
// export const apiURL = "http://docs.rhino3d.work/server";
// export const appPath = "/";
// export const isDevelopEnv = false;
// // 编译配置结束----------------------------------------------

// // 本地开发配置 ------------------------------------------
// // -----------------------------------------------------
// // 本地测试用：
// export const apiURL = "http://localhost:8000";
// export const appPath = "/docs/";
// 启用开发环境
// export const isDevelopEnv = true;
// -----------------------------------------------------
// 开发配置结束-------------------------------------------


